import { UseBaseQueryOptions, useQuery } from '@tanstack/react-query'
import { getDynamicPagePresets } from '../../services'
import { DynamicPagePresetQueryKeys } from '@/modules/client-setting/keys'
import type { GetDynamicPagePresetsResponse } from '@/modules/client-setting/type'

export default function useQueryGetDynamicPagePresets(
	props?: UseBaseQueryOptions<GetDynamicPagePresetsResponse>,
) {
	return useQuery({
		queryKey: [DynamicPagePresetQueryKeys.GetDynamicPagePresets],
		queryFn: () => getDynamicPagePresets(),
		...props,
	})
}
